import Actions from '../../odata/actions';

const actions = new Actions('notificationReceipt', 'notificationReceipts');

export default actions;
